import { CircularProgress } from '@mui/material';
import Grid from '@mui/material/Grid';
import { purchaseOrderDetailAiraloAction } from '_models/redux/airalo-purchase-details/action';
import PageListSimIpb from 'modules/list-sim-ipb/page';
import OrdersDatagrid from 'modules/my-sales/submodules/orders/list/widgets/OrdersDatagrid';
import ContentRechargeHistory from 'modules/support/my-tickets/flow/detailTickets/components/ContentRechargeHistoryComponent';
import PageTransactionsMercadoPago from 'modules/transactions-mercadopago/page';
import PageNetPay from 'modules/transactions-netpay/page';
import PageTransactionsOpenPay from 'modules/transactions-openpay/page';
import PageSTP from 'modules/transactions-stp/page';
import PageTOKU from 'modules/transactions-toku/page';
import PageYuno from 'modules/transactions-yuno/page';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import CustomDialog from 'widgets/component/CustomDialog';
import DataTableDetailOrder from 'widgets/customDialogComponentDetails/ComponentDialog';
import TransactionCardSummary from './TransactionCardSummary';

const TransactionCard = ({
  type,
  transactionType,
  title,
  onClose,
  payment_type,
  idTransaction,
  namePayment,
  response,
  responsePurchaseDetailsAiralo,
  purchaseOrderDetailAiraloAction,
}) => {
  const [showRechargeHistory, setShowRechargeHistory] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isNetPay, setIsNetPay] = useState(false);
  const [isSTP, setIsSTP] = useState(false);
  const [isTOKU, setIsTOKU] = useState(false);
  const [isIPB, setIsIPB] = useState(false);
  const [isOpenPay, setIsOpenPay] = useState(false);
  const [isMercadoPago, setIsMercadoPago] = useState(false);
  const [isYuno, setIsYuno] = useState(false);

  const handleCloseTransactionDialog = () => {
    setShowRechargeHistory(false);
  };
  const transactionId = response?.transaction_type?.transaction_id;
  const isAiraloTransactionType = type === 'AiraloDetails';

  const canViewDetails =
    namePayment === 'YUNO'
      ? Boolean(idTransaction)
      : (response?.payment_provider !== null && response?.payment_provider !== undefined) ||
        (transactionId !== null && transactionId !== undefined);

  const handleViewDetails = () => {
    if (payment_type === 'Compra eSIM Viajero' && transactionId) {
      purchaseOrderDetailAiraloAction(transactionId);
    }
    setShowRechargeHistory(true);
  };

  useEffect(() => {
    if (showRechargeHistory) {
      setIsNetPay(namePayment === 'NetPay');
      setIsSTP(namePayment === 'STP');
      setIsTOKU(namePayment === 'TOKU');
      setIsOpenPay(namePayment === 'OpenPay');
      setIsIPB(namePayment === 'IPB');
      setIsMercadoPago(namePayment === 'MercadoPago');
      setIsYuno(namePayment === 'YUNO');
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showRechargeHistory]);

  if (loading) {
    return (
      <Grid
        container
        justifyContent='center'
        alignItems='center'
        style={{
          height: '100%',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          zIndex: 10,
        }}
      >
        <CircularProgress />
      </Grid>
    );
  }
  if (isNetPay) {
    return <PageNetPay transactionId={idTransaction} onClose={onClose} />;
  }
  if (isSTP) {
    return <PageSTP transactionId={idTransaction} onClose={onClose} />;
  }
  if (isTOKU) {
    return <PageTOKU transactionId={idTransaction} onClose={onClose} />;
  }
  if (isIPB) {
    return <PageListSimIpb transactionId={idTransaction} onClose={onClose} />;
  }
  if (isOpenPay) {
    return <PageTransactionsOpenPay transactionId={idTransaction} onClose={onClose} />;
  }
  if (isMercadoPago) {
    return <PageTransactionsMercadoPago transactionId={idTransaction} onClose={onClose} />;
  }
  if (isYuno) {
    return <PageYuno transactionId={idTransaction} onClose={onClose} />;
  }
  if (showRechargeHistory) {
    if (payment_type === 'Recarga') {
      return <ContentRechargeHistory transactionId={idTransaction} onClose={onClose} />;
    } else if (payment_type === 'Compra') {
      return <OrdersDatagrid transactionId={idTransaction} onClose={onClose} />;
    } else if (payment_type === 'IPB') {
      return <PageListSimIpb transactionId={idTransaction} onClose={onClose} />;
    } else if (payment_type === 'Compra eSIM Viajero') {
      return (
        <CustomDialog
          fullWidth
          title='Detalle Orden de Compra Airalo'
          content={
            responsePurchaseDetailsAiralo?.state === 'success' &&
            responsePurchaseDetailsAiralo?.response &&
            Object.keys(responsePurchaseDetailsAiralo?.response).length > 0 ? (
              <DataTableDetailOrder
                type='AiraloDetails'
                response={responsePurchaseDetailsAiralo?.response}
                idTransaction={
                  response?.payment_info?.id ||
                  response?.payment_info?.[0]?.payment_id ||
                  response?.payment_id ||
                  transactionId
                }
              />
            ) : (
              'No hay información de proveedor para mostrar el detalle de esta transacción.'
            )
          }
          open={true}
          onClose={handleCloseTransactionDialog}
          maxWidth='md'
          extraButtons={[
            {
              label: 'Aceptar',
              variant: 'contained',
              onClick: handleCloseTransactionDialog,
              buttonColor: 'purple',
              textColor: 'white',
            },
          ]}
        />
      );
    }
  }
  return (
    <TransactionCardSummary
      title={title}
      response={response}
      transactionType={transactionType}
      isAiraloTransactionType={isAiraloTransactionType}
      handleViewDetails={handleViewDetails}
      canViewDetails={canViewDetails}
    />
  );
};
const mapStateToProps = (state) => ({
  responsePurchaseDetailsAiralo: state?.responsePurchaseDetailsAiralo,
});
const mapDispatchToProps = {
  purchaseOrderDetailAiraloAction,
};
export default connect(mapStateToProps, mapDispatchToProps)(TransactionCard);
